import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConstsHelper } from '../../../helpers/consts.helper';
import { PaymentDetailsInterface } from '../../shared/models/payment-details.interface';
import { VadSubscriptionService } from '../../shared/services/vad-subscription.service';
import { ActivatedRoute } from '@angular/router';
import { TokenLocalStorageService } from '../../authentication/services/token-local-storage.service';
import { LoginResponseInterface } from '../../authentication/models/login-response.interface';
import { VadSubscriptionInterface } from '../../shared/models/vad-subscription.interface';
import { CustomerService } from '../../account/services/customer.service';
import { RibInterface } from '../../account/models/rib.interface';
import { select, Store } from '@ngrx/store';
import { GetCustomer } from '../../account/store/actions/customer.actions';
import { UpdateLoaderVisibility } from '../../shared/store/actions/loader.actions';
import { Actions, ofType } from '@ngrx/effects';
import {
  EPartnerSubscriptionActions,
  PartnerSubscriptionSuccess
} from '../../shared/store/actions/partner-subscription.actions';
import { DeleteToken } from '../../authentication/store/actions/login.actions';
import { CustomerInterfaceState } from '../../account/store/state/customer.state';
import { CustomerInterface } from '../../account/models/customer.interface';
import moment from 'moment';
import { VadSubscriptionProductInterface } from '../../shared/models/vad-subscription-product.interface';

@Component({
  selector: 'app-finalize-subscription',
  templateUrl: './finalize-subscription.component.html',
  styleUrls: ['./finalize-subscription.component.css'],
  standalone: false
})
export class FinalizeSubscriptionComponent implements OnInit {

  brand = environment.data.brand;
  form: FormGroup;
  formSubmitted: boolean;
  recapContract: boolean;
  retractation: boolean;
  acceptSepa: boolean;
  isValidToken: boolean|null;
  step: number;
  fees: number|null;
  errorMessage: string|null;
  cgvUrl = environment.data.cgvUrl;
  cgaUrl = environment.data.cga;
  customer: CustomerInterface|null;
  vadSubscription: VadSubscriptionInterface|null;
  products: Array<VadSubscriptionProductInterface>;

  errors: any = {
    iban: {
      required: `L'IBAN est requis.`,
      pattern: `L'IBAN saisie n'est pas valide.`
    },
    bic: {
      required: `Le BIC est requis.`,
      pattern: `Le BIC saisie n'est pas valide.`
    }
  };

  paymentDetailsInterface = {
    redirectLink: null,
    externalId: null,
    errorMessage: 'Votre paiement a été annulé ou refusé.',
    procedureCode: ConstsHelper.PROCEDURE_PARTNER_SUBSCRIPTION,
    type: ConstsHelper.PROCEDURE_PARTNER_SUBSCRIPTION,
    procedureType: null,
    selectedLine: null,
    payload: {},
    amount: 0,
  } as PaymentDetailsInterface;

  constructor(
      private store: Store<any>,
      private action$: Actions,
      private formBuilder: FormBuilder,
      private activateRoute: ActivatedRoute,
      private customerService: CustomerService,
      private localStorageService: TokenLocalStorageService,
      private vadSubscriptionService: VadSubscriptionService,
  ) {}

  ngOnInit() {
    localStorage.removeItem('local_storage_payment_' + this.paymentDetailsInterface.type);
    this.acceptSepa = false;
    this.recapContract = false;
    this.retractation = false;
    this.isValidToken = null;
    this.customer = null;
    this.formSubmitted = false;
    this.vadSubscription = null;
    this.errorMessage = null;
    this.step = 1;
    this.products = [];
    this.store.dispatch(new UpdateLoaderVisibility(1));
    this.vadSubscriptionService.getDetails(this.activateRoute.snapshot.params.token).subscribe(
        response => {
          this.fees = response.totalAmount / response.products.length;
          this.isValidToken = true;
          this.paymentDetailsInterface.amount = response.totalAmount;
          this.paymentDetailsInterface.externalId = response.procedureId.toString();
          this.store.dispatch(new UpdateLoaderVisibility(-1));
          const tokenData: LoginResponseInterface = {
            id: response.id,
            session: response.session,
            email: response.email,
            token: response.token,
            expiration: response.expiration,
          };
          this.vadSubscription = response;
          for (const product of this.vadSubscription.products) {
            if (this.products.findIndex(p => p.offer_id === product.offer_id) === -1) {
              this.products.push(product);
            }
          }
          this.localStorageService.save(tokenData, false);
          this.store.dispatch(new GetCustomer());
          this.initIbanForm();
        }, error => {
          this.isValidToken = false;
        }
    );

    this.action$.pipe(ofType(EPartnerSubscriptionActions.PartnerSubscriptionSuccess)).subscribe((result: PartnerSubscriptionSuccess) => {
      if (result) {
        this.step = 3;
        this.store.dispatch(new DeleteToken());
      }
    });

    this.store.pipe(select(ConstsHelper.REDUCER_CUSTOMER)).subscribe( (result: CustomerInterfaceState) => {
      if (null != result.customer) {
        this.customer = result.customer;
      }
    });
  }

  initIbanForm() {
    this.form = this.formBuilder.group({});
    this.form.addControl('iban', this.formBuilder.control('', [Validators.required]));
    this.form.addControl('bic', this.formBuilder.control('', [Validators.required, Validators.pattern(ConstsHelper.bicPattern)]));
  }

  saveIban() {
    this.formSubmitted = true;
    this.errorMessage = null;
    if (this.form.valid) {
      const data: RibInterface = {
        iban: this.form.get('iban').value,
        bic: this.form.get('bic').value,
        password: null,
        linkedCustomerId: null,
      };
      this.formSubmitted = false;
      this.store.dispatch(new UpdateLoaderVisibility(1));
      this.customerService.setIbanBic(data).subscribe(
          result => {
            this.store.dispatch(new UpdateLoaderVisibility(-1));
            this.step = 2;
          }, error => {
            this.store.dispatch(new UpdateLoaderVisibility(-1));
            this.errorMessage = 'L\'IBAN saisie n\'est pas valide.';
          }
      );
    }
  }

  getError(formControlName: string): string {
    let errorMsg = '';
    if (this.form.controls[formControlName].invalid) {
      Object.keys(this.form.controls[formControlName].errors).map(
          key => {
            errorMsg = this.errors[formControlName][key];
          }
      );
    }
    return errorMsg;
  }

  setRetractation($event) {
    this.retractation = $event.target.checked;
  }

  setRecapContract($event) {
    this.recapContract = $event.target.checked;
  }

  formatDate(portabilityDate: string) {
    return moment(portabilityDate, 'YYYY-MM-DD').format('DD/MM/YYYY');
  }

  setSepa($event) {
    this.acceptSepa = $event.target.checked;
  }
}
